import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import { FormGroup, NgForm } from '@angular/forms';
import {MatDialogRef, MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatStepper } from '@angular/material/stepper';
import { Observable, Subscription } from 'rxjs';
import { DashboardService } from '../../dashboard.service';
import { AdminLanguageService } from '../../services/admin-language-service/admin-language.service';

@Component({
  selector: 'app-delete-dialog',
  templateUrl: './delete-dialog.component.html',
  styleUrls: ['./delete-dialog.component.scss'],
  standalone: false
})
export class DeleteDialogComponent implements OnInit {

  downloadUrl$: Observable<string>
  downloadUrlSub: Subscription
  labels;
  labelsSub: Subscription;
  constructor(public snackBar: MatSnackBar, public dialog: MatDialog, public dialogRef: MatDialogRef<DeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,private dashboardService:DashboardService, private adminLanguageService:AdminLanguageService,) { }
    @ViewChild('editForm') editForm:NgForm


  ngOnInit(): void {
    this.getLang()
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  goBack(stepper: MatStepper){
    stepper.previous()
  }

  deleteFile() {
    this.dashboardService.deleteGeneratedFile(this.data._id).toPromise().then((res) => {
      this.snackBar.open(`${this.labels.lblReport} "${this.data.filename}" ${this.labels.lblIsDeleted}`, 'OK', {
        duration: 2000,
        verticalPosition: 'top',
        horizontalPosition: 'end',

      });
      this.dialogRef.close();
    }).catch((err) => {
      console.log(err);
      this.snackBar.open(`${this.labels.lblReportGeneratedError}`, 'OK', {
        duration: 2000,
        verticalPosition: 'top',
        horizontalPosition: 'end',
      });
    });
  }

  getLang(){
    this.labelsSub = this.adminLanguageService.labels$.subscribe((labels) => {
      this.labels = labels;
      })
  }

}
